/**
 * @file
 * @prettier
 */

import { InitializeIncomeChangePages } from "./IncomeChangePages.js";

export function InitializeIncomeChangeSecondOccupationPage() {
  InitializeIncomeChangePages();
}
